import React from 'react';
import { object } from 'prop-types';
import css from './SeoDiscovery.module.css';

const formatPhoneHref = phone => `tel:${String(phone).replace(/[^\d+]/g, '')}`;

const SeoVenueContact = props => {
  const { contact } = props;
  if (!contact) {
    return null;
  }

  const { address, phone, email, hours } = contact;
  const items = [
    hours ? { label: 'Hours of operation', value: hours } : null,
    phone ? { label: 'Phone', value: phone, href: formatPhoneHref(phone) } : null,
    email ? { label: 'Email', value: email, href: `mailto:${email}` } : null,
    address ? { label: 'Address', value: address } : null,
  ].filter(Boolean);

  if (!items.length) {
    return null;
  }

  return (
    <section className={css.section}>
      <h2>Contact information</h2>
      <ul className={css.contactList}>
        {items.map(item => (
          <li key={item.label} className={css.contactListItem}>
            <span className={css.contactLabel}>{item.label}</span>
            {item.href ? (
              <a href={item.href}>{item.value}</a>
            ) : (
              <span>{item.value}</span>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
};

SeoVenueContact.propTypes = {
  contact: object,
};

export default SeoVenueContact;
